// src/features/auth/signup/FormSection.jsx
import React from 'react';
import InputField from './InputField';
import PasswordField from './PasswordField';
import TermsCheckbox from './TermsCheckbox';

const FormSection = ({ register, setValue, handleSubmit, onSubmit, errors, selectedRole }) => (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <InputField
            id="nombre"
            label="Nombre(s)"
            placeholder="Ej. Juan Pablo"
            register={register}
            errors={errors}
            autoComplete="given-name"
            validation={{
                required: 'El nombre es obligatorio',
                minLength: { value: 2, message: 'Debe tener al menos 2 caracteres' },
            }}
        />

        <InputField
            id="apellido"
            label="Apellido(s)"
            placeholder="Ej. Herrera Perez"
            register={register}
            errors={errors}
            autoComplete="family-name"
            validation={{
                required: 'El apellido es obligatorio',
                minLength: { value: 2, message: 'Debe tener al menos 2 caracteres' },
            }}
        />

        <InputField
            id="email"
            label="Correo electrónico"
            type="email"
            placeholder="ejemplo@correo.com"
            register={register}
            errors={errors}
            autoComplete="email"
            validation={{
                required: 'El correo es obligatorio',
                pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Correo no válido' },
            }}
        />

        {/* Company name — only for inmobiliaria */}
        {selectedRole === 'inmobiliaria' && (
            <div className="sm:col-span-2">
                <InputField
                    id="nombre_empresa"
                    label="Nombre de la empresa"
                    placeholder="Ej. Inmobiliaria ABC S.A.S."
                    register={register}
                    errors={errors}
                    validation={{ required: 'El nombre de la empresa es obligatorio' }}
                />
            </div>
        )}

        <InputField
            id="telefono"
            label="Teléfono"
            placeholder="Ej. +57 300 123 4567"
            register={register}
            errors={errors}
            validation={{
                required: 'El teléfono es obligatorio',
                pattern: { value: /^\+?\d{9,15}$/, message: 'Formato de teléfono inválido' },
            }}
        />

        <PasswordField register={register} errors={errors} />

        <div className="sm:col-span-2">
            <TermsCheckbox register={register} errors={errors} setValue={setValue} />
        </div>

        <div className="sm:col-span-2 mt-2">
            <button type="submit" className="w-full btn-primary py-3 rounded-xl font-semibold">
                Registrarse
            </button>
        </div>
    </form>
);

export default FormSection;
